export enum OrganizationMemberClientAccessSource {
    SWITCHER = "switcher",
    CLIENTS_LIST = "clients_list",
    HYDRATE = "hydrate",
    OTHER = "other",
}

export enum OrganizationMemberClientAccessSort {
    CREATED_AT_ASC = "createdAt_asc",
    CREATED_AT_DESC = "createdAt_desc",
}

export interface OrganizationMemberClientAccess {
    id: string;
    organizationId: string;
    userId: number;
    clientWorkspaceId: string;
    previousWorkspaceId: string | null;
    source: OrganizationMemberClientAccessSource;
    createdAt: Date;
    traceId: string | null;
}
